import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const GENRES = ["R&B", "Soul", "Gospel", "Pop", "Hip-Hop"];
const CREDITS = ["Songwriter.", "Producer.", "Storyteller."];

export const Manifesto = () => {
  return (
    <section className="section-pad" data-testid="about-teaser-section">
      <div className="mx-auto max-w-[1360px] px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        {/* Left: portrait in corner-bracket frame with pull quote */}
        <Reveal>
          <div className="frame p-3" style={{ backgroundColor: "var(--ink-raised)" }}>
            <div className="relative overflow-hidden" style={{ borderRadius: "var(--radius)" }}>
              <img
                src="/assets/img/headshot-1280.webp"
                onError={(e) => { e.currentTarget.src = "/assets/img/headshot-1280.jpg"; }}
                alt="Perry Frazier, P. Frazy"
                className="w-full h-auto"
                style={{ borderRadius: "var(--radius)" }}
              />
              <div
                className="absolute inset-x-0 bottom-0 p-6"
                style={{ background: "linear-gradient(0deg, rgba(11,9,8,.92) 15%, transparent 100%)" }}
              >
                <p className="font-script text-gold" style={{ fontSize: "2.75rem", lineHeight: 1 }}>
                  &ldquo;The most powerful sound is feeling.&rdquo;
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        {/* Right: condensed bio */}
        <Reveal delay={0.08}>
          <p className="font-caps text-gold" style={{ fontSize: ".72rem" }}>The Man Behind the Music</p>
          <h2 className="font-display foil-text mt-3" style={{ fontSize: "var(--t-h2)", lineHeight: 1.05 }}>
            Perry Frazier
          </h2>

          <div className="mt-6 space-y-4" style={{ color: "var(--parchment)" }}>
            <p>
              Perry Frazier — professionally known as P. Frazy — is an independent songwriter and music producer who creates songs that speak to the heart.
            </p>
            <p>
              His songs blend contemporary R&amp;B, soul, inspirational, and gospel influences to tell authentic stories of love, faith,
              relationships, and personal transformation — drawn from life&rsquo;s victories, disappointments, and his own spiritual journey.
            </p>
            <p>
              He is also the founder of Heart N Soul Records, the independent label he built for exactly this kind of work.
            </p>
            <p className="font-caps text-gold" style={{ fontSize: ".72rem" }}>Feel it. Create it. Make it timeless.</p>
          </div>

          <Link to="/about" className="link-underline inline-block mt-6 font-caps" style={{ fontSize: ".72rem" }} data-testid="read-full-story">
            Read the full story →
          </Link>

          {/* Credits with rose heart dividers */}
          <div className="flex flex-wrap items-center gap-3 mt-10 font-caps" style={{ fontSize: ".72rem", color: "var(--parchment)" }}>
            {CREDITS.map((c, i) => (
              <span key={c} className="inline-flex items-center gap-3">
                {c}
                {i < CREDITS.length - 1 && <Heart size={12} fill="var(--rose)" color="var(--rose)" />}
              </span>
            ))}
          </div>

          {/* Genre pills */}
          <div className="flex flex-wrap gap-3 mt-6">
            {GENRES.map((g) => (
              <span key={g} className="pill" data-testid={`genre-${g}`}>{g}</span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
